import { APICore } from './apiCore'

const api = new APICore()

function getCategoriasEnlaces (params) {
  const baseUrl = '/categorias-enlaces'
  return api.get(baseUrl, params)
}

function getCategoriaEnlaces (id) {
  const baseUrl = `/categorias-enlaces/${id}`
  return api.get(baseUrl, {})
}

function addCategoriaEnlaces (params) {
  const baseUrl = '/categorias-enlaces'
  return api.createWithFile(baseUrl, params)
}

function updateCategoriaEnlaces (params) {
  const baseUrl = '/categorias-enlaces'
  return api.updateWithFile(baseUrl, params)
}

function deleteCategoriaEnlaces (params) {
  const baseUrl = '/categorias-enlaces'
  return api.delete(baseUrl, params)
}

export { getCategoriasEnlaces, getCategoriaEnlaces, addCategoriaEnlaces, updateCategoriaEnlaces, deleteCategoriaEnlaces }
